import { Module } from 'vuex'
import { RootState } from '../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import State from './types'
import _ from 'lodash'
import { blankConfiguration, blankRequest } from './constants'

export const state: State = {
  materials: [],
  materialsCatalogLoaded: false,
  request: _.assign({}, _.cloneDeep(blankRequest)),
  configuration: _.assign({}, _.cloneDeep(blankConfiguration)),
  configurationLoaded: 0,
  Error: false,
}

const namespaced = true

export const configurableMaterial: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
